import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CVEtable from "./CVEtable";
import http from "../services/httpService.js";
import BarLoader from "react-spinners/BarLoader";
const { SERVER_BASE_URL } = require("../env");

function Home() {
  const [cves, setCVEs] = useState([]);
  const [program, setProgram] = useState([]);
  let [loading, setLoading] = useState(true);
  const [isThereAnyCVE, setIsThereAnyCVE] = useState(false);
  let { cpeId } = useParams();

  useEffect(() => {
    async function fetchData() {
      const response = await http.get(
        `${SERVER_BASE_URL}/my-cpes/${cpeId}/cves`,
        {
          headers: { "x-auth-token": localStorage.getItem("token") },
        }
      );
      setProgram(response.data.cpeTitle);
      setCVEs(response.data.cves);
      if (response.data.cves.length) setIsThereAnyCVE(true);
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className="centeral-container">
      <div className="farsi-bold page-top-title">
        آسیب‌پذیری‌های برنامه {program}
      </div>
      <BarLoader
        className="mt-3"
        color={"#a4b5ff"}
        loading={loading}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {isThereAnyCVE && <CVEtable items={cves} cpeId={cpeId}></CVEtable>}

      {!isThereAnyCVE && !loading && (
        <div className="no-cve-text farsi">
          هیچ آسیب‌پذیری‌ای برای این برنامه یافت نشد!
        </div>
      )}
    </div>
  );
}

export default Home;
